const { useQuery, gql } = require("@apollo/client");

const FETCH_ODOO_PRODUCT = gql`
  query FETCH_ODOO_PRODUCT($id: Int!, $instance: String) {
    odooProduct(id: $id, instance: $instance) {
      id
      name
      displayName
      defaultCode
    }
  }
`;

const useOdooProduct = (id, instance) => {
  const { data } = useQuery(FETCH_ODOO_PRODUCT, {
    variables: { id, instance },
    skip: !id,
  });

  return data ? data.odooProduct : null;
};

const FETCH_ODOO_PRODUCTS = gql`
  query FETCH_ODOO_PRODUCTS($ids: [Int], $barcodes: [String]) {
    odooProducts(ids: $ids, barcodes: $barcodes)
  }
`;

export const useOdooProducts = ({ ids, barcodes }) => {
  const { loading, error, data } = useQuery(FETCH_ODOO_PRODUCTS, {
    variables: { ids, barcodes },
  });

  const odooProducts = data ? JSON.parse(data.odooProducts) : null;

  return { loading, error, odooProducts };
};

export default useOdooProduct;
